import { render, staticRenderFns } from "./DocumentosDigitales.vue?vue&type=template&id=c1b3bc0c&scoped=true&"
import script from "./DocumentosDigitales.vue?vue&type=script&lang=js&"
export * from "./DocumentosDigitales.vue?vue&type=script&lang=js&"
import style0 from "./DocumentosDigitales.vue?vue&type=style&index=0&id=c1b3bc0c&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1b3bc0c",
  null
  
)

export default component.exports